let systemConfig = window.systemConfig
export default {
  // 企信
  chat: {
    qixin: systemConfig && systemConfig.qixin ? systemConfig.qixin.en : 'qixin',
    open: 'unfold',
    communicate: 'click to communicate with colleagues in real time',
    Initiatechat: 'initiate a chat',
    groupchat: 'select group chat',
    chat: 'chat',
    seemore: 'see more messages',
    unread: 'not read',
    already: 'readed',
    peoplehaveread: 'People have already read',
    allread: 'All have been read',
    withdraw: 'withdraw',
    Noannouncement: 'There is no group announcement',
    Groupmembers: 'group members',
    Addmember: 'add members',
    manage: 'administrator',
    Groupchatstaff: 'Group chat full',
    Groupannouncement: 'Group of announcement',
    transfer: 'Transfer group chat',
    topchat: 'Top chat',
    toptalk: 'Session set-top',
    dissolve: 'the dissolution of chatting',
    quit: 'exit the group chat',
    expression: 'expression',
    newmessage: ' new message',
    entersend: 'press Enter to send the message',
    send: 'send',
    view: 'see the group chat',
    quitTip:
      'After quitting, you will no longer accept messages from the group. Please use caution.Are you sure you want to quit group chatting?',
    dissolveTip:
      'Tip: after disbanding, the group chat cannot be resumed. Members in the group chat will receive the disbanding message. Please be careful.',
    dissolve2: 'Are you sure you want to break up?',
    selectmember: 'select member',
    readnotread: 'read or not',
    messagedetails: 'Message details',
    read: 'readed',
    notread: 'not read',
    groupmemberlist: '@Group member list',
    draft: 'draft',
    everyone: 'everyone',
    message_empty: 'Cannot send blank message!',
    person: 'person',
    recalled1: 'The other party withdrew a message',
    recalled2: 'You withdrew a message',
    recalled3: 'A message was withdrawn',
    you: 'you',
    message_long: 'The message is too long, please send it separately!',
    selecttransfer: 'Please choose to transfer members!',
    welcome: 'welcome',
    jointhisgroup: 'join this group',
    adminwill: 'the administrator will',
    removegroup: 'removed from the group chat',
    messagecenter: ' message center',
    markallread: 'All are marked as read',
    modulename: 'module name',
    robot: 'robot',
    onlyunread: 'View only unread messages',
    noauthority: 'no right to view or data deleted',
    addmemo: 'add new memorandum',
    // 20210305
    residueprocessingtime: 'Remaining processing time',
    hasatimeout: 'Timed out'
  }
}
